'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _browser = require('@beastshop/browser');

var _browser2 = _interopRequireDefault(_browser);

var _simpleSemver = require('simple-semver');

var _events = require('events');

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var undefined = void 0;
var bridge = {};
var base = (0, _base2.default)();
var version = function () {
  var app = _browser2.default.app();
  if (!app) {
    return '0.0.0';
  }
  return app.version;
}();

function NOOP() {}

bridge.__proto__ = _events.EventEmitter.prototype;

exports.default = bridge;


bridge.upload = function (data) {
  return base.invoke('upload', data).then(function (result) {
    return result ? result : _promise2.default.reject(cancelError());
  });
};

bridge.sign = function (data) {
  return base.invoke('sign', data).then(function (result) {
    return result ? result : _promise2.default.reject(cancelError());
  });
};

bridge.record = function (data) {
  return base.invoke('record', data).then(function (result) {
    return result ? result : _promise2.default.reject(cancelError());
  });
};

bridge.selectCoupon = function (data) {
  return base.invoke('selectCoupon', data);
};

bridge.selectGiftCard = function (data) {
  return base.invoke('selectGiftCard', data);
};

bridge.uploadIdCard = function (data) {
  return base.invoke('uploadIdCard', data).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.selectIdCardAuthentication = function (data) {
  // since 4.3.0
  return base.invoke('selectIdCardAuthentication', data).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.selectIdCard = function (data) {
  // uniapp 6.0.0
  return base.invoke('selectIdCard', data).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.customProductCard = function (data) {
  // since 4.3.0
  return base.invoke('customProductCard', data).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.selectProductVariant = function (data) {
  return base.invoke('selectProductVariant', data).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.share = function (data) {
  return base.invoke('share', data).then(function (result) {
    switch (typeof result === 'undefined' ? 'undefined' : (0, _typeof3.default)(result)) {
      case 'object':
        if (!result.state) {
          return _promise2.default.reject(newError('UNKNOWN'));
        }
        if (result.state === 'SUCCESS') {
          return _promise2.default.resolve();
        }
        if (result.state === 'FAILED') {
          return _promise2.default.reject(cancelError());
        }
        return _promise2.default.reject(newError(result.state));
        break;
      case 'boolean':
        return result ? _promise2.default.resolve() : _promise2.default.reject(cancelError());
        break;
      default:
        return _promise2.default.reject(newError('UNKNOWN'));
    }
  });
};

bridge.scan = function () {
  var _resolve = void 0,
      _reject = void 0;
  var promise = new _promise2.default(function (resolve, reject) {
    _resolve = resolve;
    _reject = reject;
  });

  base.invoke('scan', {}).then(function (result) {
    if (result) {
      _resolve(result);
    } else {
      _reject();
    }
  });
  return promise;
};

bridge.ensureLogged = function () {
  return base.invoke('ensureLogged', {}).then(function (status) {
    return !status.abort ? _promise2.default.resolve(status) : _promise2.default.reject(cancelError());
  });
};[
// 'ensureLogged',
'removeButton', // deprecated
'removeLeftButton', // deprecated
'closeFancyDialog', 'closeWebviewDialog'].forEach(function (action) {
  bridge[action] = function () {
    return base.invoke(action, {});
  };
});

var listeners = {
  message: {
    // when there is a broadcast message
    handler: 'broadcast'
  },
  show: {
    // when the navigation returns to the webview
    handler: (0, _simpleSemver.gte)(version, '1.7.0')
    // event 'return' renamed as 'show' since 1.7
    ? 'show' : 'return'
  },
  hide: {
    handler: 'hide'
  },
  share: {
    handler: 'share'
  },
  login: {
    handler: 'login'
  },
  init: {
    handler: 'pageData'
  },
  cart_change: {
    handler: 'cart_change'
  },
  scan_result: {
    handler: 'scan_result'
  },
  scan_dismiss: {
    handler: 'scan_dismiss'
  },
  did_selected_staff: {
    handler: 'did_selected_staff'
  }
};

var on = bridge.on;
bridge.on = function (type, handler) {
  var listener = listeners[type];

  if (!listener) {
    return bridge;
  }

  if (!listener.listened) {
    listener.listened = true;

    // < 1.4
    handle_open_data(type, handler);

    base.handler(listener.handler, function (data) {
      bridge.emit(type, data);
    });
  }

  return on.call(bridge, type, handler);
};

bridge.getLocation = function () {
  return new _promise2.default(function (res, rej) {
    base.invoke('getLocation', {}).then(function (result) {
      result.authorized ? res(result) : rej(result);
    });
  });
};

bridge.getMember = function () {
  var _resolve = void 0,
      _reject = void 0;
  var promise = new _promise2.default(function (resolve, reject) {
    _resolve = resolve;
    _reject = reject;
  });

  if (_browser2.default.android() && (0, _simpleSemver.lt)(version, '1.3.0')) {
    bridge.ajax({
      url: '/app/member'
    }).then(function (_ref) {
      var data = _ref.data;

      data ? _resolve(data) : base.invoke('getMember', {}).then(_resolve);
    }).catch(function () {
      base.invoke('getMember', {}).then(_resolve);
    });
  } else {
    base.invoke('getMember', {}).then(_resolve);
  }
  return promise;
};

bridge.showLoading = function () {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (_browser2.default.android() && (0, _simpleSemver.lt)(version, '1.10.0')) {
    if (Object(title) !== title) {
      title = { title: title };
    }

    title.type = title.type || 'toast';

    base.invoke('showLoading', { title: title });
    return;
  }

  if (Object(title) !== title) {
    title = { text: title };
  }

  // @type {String} type 'toast' or 'page'
  title.type = title.type || 'toast';

  base.invoke('showLoading', title);
};

bridge.hideLoading = function () {
  base.invoke('hideLoading', {});
};

bridge.broadcast = function (data) {
  return base.invoke('broadcast', data);
};

bridge.setTitle = function (data) {
  if (Object(data) !== data) {
    data = {
      type: 'text',
      value: data
    };
  }

  return base.invoke('setTitle', data);
};

bridge.setNavigation = function (data) {
  if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object') {
    return;
  }
  data = {
    bgColor: data.bgColor,
    shadowColor: data.shadowColor
  };
  return base.invoke('setNavigation', data);
};

bridge.select = function (data, callback) {
  var newVersion = (0, _simpleSemver.gte)(version, '1.10.0');
  data.selectIndex = data.selectIndex || 0;
  data.options = data.options || [];
  data.options = data.options.map(function (el) {
    if (typeof el === 'string') {
      return newVersion ? {
        text: el,
        icon: '',
        hint: ''
      } : el;
    }
    if ((typeof el === 'undefined' ? 'undefined' : (0, _typeof3.default)(el)) === 'object') {
      return newVersion ? el : el.text || '';
    }
    return el;
  });
  return base.invoke('select', data).then(function (result) {
    if (!newVersion) {
      return result;
    }
    return result.action === 'USER_CANCEL' ? _promise2.default.reject(cancelError()) : result.index;
  });
};

bridge.pay = function (data) {
  return base.invoke('pay', data);
};

bridge.notify = function (type) {
  base.invoke('notify', {
    type: type
  });
};

bridge.open = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof options === 'string') {
    options = {
      url: options
    };
  }

  if ((0, _simpleSemver.lt)(version, '1.4.0')) {
    save_open_data(options.data);
  }

  base.invoke('open', options);
};

// @param {String} id not supported yet
bridge.closeWindow = function (data) {
  base.invoke('closeWindow', {
    id: undefined,
    message: data || ''
  });
};

bridge.pageBack = function (data) {
  base.invoke('pageBack', {
    id: undefined,
    message: data || ''
  });
};

bridge.toast = function (text) {
  return base.invoke('toast', { text: text });
};

//since to 1.4
bridge.weekSendFlower = function (data) {
  return base.invoke('weekSendFlower', data);
};

// Old buttons, deprecated since 1.2
/////////////////////////////////////////////////////////////////////

function _setButton(type, data, handler_name) {
  if (Object(data) !== data) {
    data = {
      text: data
    };
  }

  var handle = data.handle;
  // delete data.handle

  if (handle) {
    base.handler(handler_name || type, handle);
  }

  return base.invoke(type, data);
}

// New buttons, since 1.2
var handlers = {};

function set_handler(type, handle) {
  var handler = handlers[type] || (handlers[type] = {});

  if (!handler.set) {
    handler.set = true;
    base.handler(type, function (data) {
      handlers[type].callback(data);
    });
  }

  handler.callback = handle;
}

// const FANCY_DIALOG = 'fancyDialog'
// bridge[FANCY_DIALOG] = (data, callback) => {
//   set_handler(FANCY_DIALOG, callback)
//   base.invoke(FANCY_DIALOG, data)
// }

;['fancyDialog', 'showNavigationBar', 'setWebViewBackgroundColor'].forEach(function (name) {
  bridge[name] = function (data, callback) {
    set_handler(name, callback);
    base.invoke(name, data);
  };
});['webviewDialog'].forEach(function (name) {
  bridge[name] = function (data) {
    return base.invoke(name, data);
  };
});

var BUTTONS_SUPPORT_HANDLER = ['TEXT', 'SHARE', 'FAVORITE'];

bridge.setButtons = function (position, buttons) {
  buttons = buttons.map(function (button) {
    if (typeof button === 'string') {
      button = {
        type: button
      };
    }

    if (button.handle) {
      var handle = button.handle;
      ~BUTTONS_SUPPORT_HANDLER.indexOf(button.type) && set_handler('button.' + button.type + (button.type === 'TEXT' ? '.' + button.text : ''), handle);
      delete button.handle;
    }

    return button;
  });

  return base.invoke('setButtons', { buttons: buttons, position: position });
};

bridge.setButton = function (data) {
  return _setButton('setButton', data, (0, _simpleSemver.lt)(version, '1.2.0') ? undefined : 'button.TEXT.' + data.text);
};

bridge.showNavigationBar = function (data) {
  return base.invoke('showNavigationBar', data).then(function (result) {
    return result ? result : _promise2.default.reject(cancelError());
  });
};

bridge.setLeftButton = function (data) {
  return _setButton('setLeftButton', data, data.type === 'BACK' || (0, _simpleSemver.lt)(version, '1.2.0') ? undefined : 'button.TEXT.' + data.text);
};

bridge.confirm = function (data) {
  if (Object(data) !== data) {
    data = {
      title: data
    };
  }

  data.primaryButtonText = data.primaryButtonText || '确认';
  data.secondaryButtonText = data.secondaryButtonText || '取消';

  return base.invoke('confirm', data).then(function (isPrimary) {
    return isPrimary ? _promise2.default.resolve() : _promise2.default.reject();
  });
};

bridge.alert = function (data) {
  if (Object(data) !== data) {
    data = {
      title: data
    };
  }

  data.buttonText = data.buttonText || '知道了';
  return base.invoke('alert', data);
};

bridge.selectAddress = function (addressId) {
  return base.invoke('selectAddress', {
    addressId: addressId
  }).then(function (result) {
    return result ? _promise2.default.resolve(result) : _promise2.default.reject(cancelError());
  });
};

bridge.actionSheet = function (data) {
  data.closeButtonText = data.closeButtonText || '返回';
  data.options = data.options || [];
  return base.invoke('actionSheet', data).then(function (index) {
    return index !== 0 && !index ? _promise2.default.reject(cancelError()) : _promise2.default.resolve(index);
  });
};

bridge.showProductList = function (data) {
  data.closeButtonText = data.closeButtonText || '返回';
  return base.invoke('showProductList', data).then(function (isPrimary) {
    return isPrimary ? _promise2.default.resolve() : _promise2.default.reject();
  });
};

bridge.openWXMiniProgram = function (data) {
  data.path = data.path || '';
  return base.invoke('openWXMiniProgram', data);
};

bridge.updateMobileVersion = function () {
  return base.invoke('updateMobileVersion', {});
};

bridge.unregisterURLProtocol = function () {
  return base.invoke('unregisterURLProtocol', {});
};

bridge.registerURLProtocol = function () {
  return base.invoke('registerURLProtocol', {});
};

bridge.customerService = function () {
  return base.invoke('customerService', {});
};

var STR_GET = 'GET';
var APPLICATION_JSON = 'application/json';
var APPLICATION_FORM = 'application/x-www-form-urlencoded';
var STR_JSON = 'json';
var HEADER_CONTENT_TYPE = 'Content-Type';
var HEADER_ACCEPT = 'Accept';
// ajax({
//   url,
//   data,
//   method,
//   headers,
//   contentType = '',
//   dataType = 'json'
//   success(data),
//   error(xhr)
// })

function is_http_success(status) {
  return status >= 200 && status < 300 || status === 304;
}

function parse_json(body) {
  if (!body) {
    return {};
  }

  try {
    var json = JSON.parse(body);
    json.code && (json.code = Number(json.code));
    return json;
  } catch (e) {}
}

function is_ajax_success(_ref2) {
  var code = _ref2.code;

  return !!code && is_http_success(code);
}

// A beast-specified ajax method
// ```
// ajax({
//   data,
//   ...
//   success: (data, xhr) => {

//   },
//   error: (message, xhr) => {

//   }
// })
// ```

// xhr
//   - status
//   - responseText
bridge.ajax = function (settings) {
  var url = settings.url,
      method = settings.method,
      _settings$headers = settings.headers,
      headers = _settings$headers === undefined ? {} : _settings$headers,
      json = settings.json,
      form = settings.form,
      _settings$dataType = settings.dataType,
      dataType = _settings$dataType === undefined ? STR_JSON : _settings$dataType;


  if (!url) {
    return;
  }

  if (settings.query) {
    settings.url += '?' + _queryString2.default.stringify(settings.query);
  }

  if (method) {
    settings.method = method.toUpperCase();
  }

  var data = void 0;

  if (json) {
    data = (0, _stringify2.default)(json);
    headers[HEADER_CONTENT_TYPE] = APPLICATION_JSON;
  } else if (form) {
    data = Object(data) === data ? _queryString2.default.stringify(form) : data;
    headers[HEADER_CONTENT_TYPE] = APPLICATION_FORM;
  }

  if (dataType === STR_JSON) {
    headers[HEADER_ACCEPT] = APPLICATION_JSON;
  }

  var _resolve = void 0,
      _reject = void 0;
  var promise = new _promise2.default(function (resolve, reject) {
    _resolve = resolve;
    _reject = reject;
  });

  function result_error(json, xhr) {
    if (!json.message) {
      json.message = '当前网络有问题，\n请重试';
    }
    _reject(json, xhr);
  }

  http_request((0, _extends3.default)({}, settings, {
    data: data,
    dataType: dataType,
    headers: headers,
    success: function success(json, xhr) {
      if (dataType !== STR_JSON) {
        return _resolve(json, xhr);
      }

      if (!is_ajax_success(json)) {
        return result_error(json, xhr);
      }

      _resolve(json, xhr);
    },
    error: function error(json, xhr) {
      if (dataType !== STR_JSON) {
        return _reject(json, xhr);
      }

      result_error(json, xhr);
    }
  }));
  return promise;
};

// A very low level http request agent
function http_request(_ref3) {
  var _ref3$success = _ref3.success,
      success = _ref3$success === undefined ? NOOP : _ref3$success,
      _ref3$error = _ref3.error,
      error = _ref3$error === undefined ? NOOP : _ref3$error,
      url = _ref3.url,
      _ref3$method = _ref3.method,
      method = _ref3$method === undefined ? STR_GET : _ref3$method,
      headers = _ref3.headers,
      data = _ref3.data,
      dataType = _ref3.dataType;


  var options = {
    url: url,
    method: method,
    headers: headers
  };

  if (data) {
    options.data = data;
  }
  base.invoke('http', options).then(function (res) {
    var status = parseInt(res.status);
    var body = res.body,
        _res$headers = res.headers,
        headers = _res$headers === undefined ? {} : _res$headers;


    function has_json(json) {
      return json !== undefined;
    }

    function callback_error(json) {
      callback_result(json, error);
    }

    function callback_success() {
      var json = void 0;

      if (dataType === STR_JSON) {
        json = body === ''
        // STR_JSON is the default value of `dataType`,
        // for most cases, an empty returned value is valid
        ? {} : parse_json(body);

        // `json` could be `false`
        // but a JSON could never be `undefined`.
        // if `json` is `undefined`, it means there is a parse error.
        if (!has_json(json)) {
          bridge.track({
            name: 'ajax-error',
            attr: {
              type: 'invalid-json',
              data: (0, _stringify2.default)({
                status: status,
                url: url,
                body: body
              })
            }
          });
          callback_error({});
          return;
        }
      }

      callback_result(json, success);
    }

    function callback_result(json, callback) {
      // if no `json`, then fallback to `body`
      callback(has_json(json) ? json : body, {
        status: status,
        body: body,
        headers: headers,
        json: json
      });
    }

    if (is_http_success(status)) {
      return callback_success();
    }

    var json = parse_json(body);
    if (json !== undefined && !json.message) {
      bridge.track({
        name: 'ajax-error',
        attr: {
          type: 'no-message',
          data: {
            status: status,
            url: url,
            body: body
          }
        }
      });
    }

    callback_error(json);
  });
}

bridge.webViewResize = _browser2.default.ios() ? (0, _simpleSemver.lt)(version, '1.2.0') ? function () {
  return base.invoke('webViewResize', {}, NOOP);
} : function () {
  return bridge.notify('webview_resize');
} : NOOP;

bridge.showError = function (data) {
  base.invoke('showError', data);
};

bridge.paySuccess = function (orderId) {
  base.invoke('paySuccess', { orderId: orderId });
};

bridge.track = function (data) {
  if ('count' in data) {
    data.attrs = data.attrs || {};
  }

  base.invoke('track', data);
};

bridge.iposShowNavigation = function () {
  base.invoke('iposShowNavigation', {});
};

bridge.iposHideNavigation = function () {
  base.invoke('iposHideNavigation', {});
};

bridge.iposMemberLogin = function () {
  return base.invoke('iposMemberLogin', {}).then(function (member) {
    return member ? _promise2.default.resolve(member) : _promise2.default.reject(cancelError());
  });
};

bridge.iposMemberLogout = function () {
  return base.invoke('iposMemberLogout', {}).then(function () {
    return _promise2.default.resolve();
  });
};

bridge.showHomePageBtn = function () {
  base.invoke('showHomePageBtn', {});
};

bridge.hiddenHomePageBtn = function () {
  base.invoke('hiddenHomePageBtn', {});
};

bridge.iposReloadHomePage = function () {
  base.invoke('iposReloadHomePage', {});
};

bridge.iposScan = function () {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var data = {};
  if (type) {
    data.type = type;
  }
  base.invoke('iposScan', data);
};

bridge.closeScan = function () {
  base.invoke('closeScan', {});
};

bridge.selectedStaff = function () {
  base.invoke('selectedStaff', {});
};

bridge.iposShouldPrintReceipt = function () {
  return base.invoke('iposShouldPrintReceipt', {}).then(function (is) {
    return is ? _promise2.default.resolve() : _promise2.default.reject();
  });
};

bridge.iposPrintReceipt = function (data) {
  base.invoke('iposPrintReceipt', data);
};

bridge.cartChanged = (0, _simpleSemver.lt)(version, '1.2.0') ? function () {
  return base.invoke('cartChanged', {});
} : function () {
  return bridge.notify('cart_size_change');
};

bridge.logMessage = function (data) {
  base.invoke('logMessage', data);
};

var OPEN_DATA_SUPPORTED = (0, _simpleSemver.gte)(version, '1.4.0');

var KEY_TO_NEXT_PAGE_DATA = '_to_next_page_data';

var get_open_data = OPEN_DATA_SUPPORTED ? NOOP : function () {
  var last_data = localStorage.getItem(KEY_TO_NEXT_PAGE_DATA);
  localStorage.removeItem(KEY_TO_NEXT_PAGE_DATA);
  if (!last_data) {
    return null;
  }
  try {
    return JSON.parse(last_data) || null;
  } catch (e) {
    return null;
  }
};

var save_open_data = OPEN_DATA_SUPPORTED ? NOOP : function (data) {
  if (!data) {
    return;
  }
  localStorage.setItem(KEY_TO_NEXT_PAGE_DATA, (0, _stringify2.default)(data));
};

var handle_open_data = OPEN_DATA_SUPPORTED ? NOOP : function (type, handler) {
  if (type === 'init') {
    var data = get_open_data();
    if (data) {
      handler(data);
    }
  }
};

function cancelError() {
  var error = new Error('USER_CANCEL');
  error.code = 'USER_CANCEL';
  return error;
}

function newError(code) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var error = new Error(message);
  error.code = code;
  return error;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/bridge/lib/index.js
// module id = 7
// module chunks = 0